// extracted by mini-css-extract-plugin
export default {"card":"HomeCard_card__uCcm2","title":"HomeCard_title__Bhg9N","description":"HomeCard_description__81YA8"};